/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DocumentDto } from '../models/DocumentDto';
import type { GetDocumentsByDdoIdsRequestDto } from '../models/GetDocumentsByDdoIdsRequestDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class DocumentsService {
    /**
     * Get documents by DDO IDs
     * Retrieves documents for the given dispatch delivery order (DDO) IDs.
     * @param requestBody
     * @returns DocumentDto List of documents for the requested DDOs
     * @throws ApiError
     */
    public static documentControllerGetDocumentsByDdoIds(
        requestBody: GetDocumentsByDdoIdsRequestDto,
    ): CancelablePromise<Array<DocumentDto>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/documents/by-ddo-ids',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation failed (ddoIds missing, not array, empty, or contains non-strings)`,
                401: `Unauthorized - Invalid or missing JWT token`,
            },
        });
    }
}
